<div class="grid">
	<div [class]="actionLayout('left')">
		<p-button id="addMtmaUnit" label="{{ 'ADD_UNIT' | translate }}" (click)="addUnit()" icon="pi cm-plus"
			[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [class]="actionLayout('center')">
		<div class="flex flex-column justify-content-center gap-2">
			<span class="flex align-items-center justify-content-center font-semibold">
				<i class="pi cm-memory-storage mr-1"></i>
				{{'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
			</span>
			<p-progressBar [value]="getValueMemory()" styleClass="surface-900">
				<ng-template pTemplate="content" let-value>
					<span *ngIf="getValueMemory() > 4">{{ getValueMemory() }} %</span>
				</ng-template>
			</p-progressBar>
		</div>
	</div>
	<div [class]="actionLayout('right')">
		<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
			<i class="pi cm-search"></i>
			<input [formControl]="searchFilter" pInputText type="text" id="units-input-search" class="surface-900"
				placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()" maxlength="60" />
		</span>
	</div>
	<div class="col-12">
		<div class="card border-round">
			<p-table #tableUnitsList dataKey="ObjId" [value]="mtmaUnits" [lazy]="true" (onLazyLoad)="loadUnits($event)"
				[paginator]="true" [totalRecords]="totalRecords" [loading]="unitssLoading" [rows]="pageSize"
				[expandedRowKeys]="expandedRows" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack"
				sortField="Name" [sortOrder]="1">
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th style="width: 5rem"></th>
						<th>
							<div pSortableColumn="Name" class="flex align-items-center justify-content-center">{{ 'NAME' |
								translate }}
								<p-sortIcon field="Name"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Code_call" class="flex align-items-center justify-content-center">{{ 'CODE_CALL'
								|
								translate }}
								<p-sortIcon field="Code_call"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Description" class="flex align-items-center justify-content-center">{{
								'DESCRIPTION' |
								translate }}
								<p-sortIcon field="Description"></p-sortIcon>
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'N_CONTACTS' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-unit let-expanded="expanded">
					<tr>
						<td>
							<p-button [pRowToggler]="unit" [rounded]="true"
								styleClass="surface-900 hover:bg-primary border-1 border-600"
								[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'"
								(click)="getContactUnits(unit)"></p-button>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ unit.Name | truncate:[50] }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'CODE_CALL' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ unit.KeyboardCode }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ unit.Description }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'N_CONTACTS' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ unit.Contacts? unit.Contacts.length: 0
								}}</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonDeviceUnitEdit-{{unit.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-pencil" size="large"
									(click)="edit(unit)" [rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" id="buttonDeviceUnitDelete-{{unit.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-trash" size="large"
									(click)="delete(unit)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-unit>
					<tr class="surface-400">
						<td colspan="12">
							<div class="flex flex-row w-full align-items-center"
								[class]="this.screenWidth > COLUMN_TITLE_MIN_WD ? 'justify-content-center' : 'justify-content-between'">
								<span class="font-semibold">{{ 'CONTACTS' | translate }}: </span>
								<p-tag *ngFor="let contact of unit.ContactsInfo, index as cont"
									value="{{cont+1}} - {{contact.Contact.Name}} {{getRuleData(contact)}}" severity="info"
									class="ml-3"></p-tag>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>